import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ErrorMessage } from '../../../../../common/models/enums/error-message';
import { InvoiceNumberSequenceRequest } from '../models/invoice-number-sequence-request';

export const FETCH_INVOICE_NUMBER_SEQUENCE = 'FETCH_INVOICE_NUMBER_SEQUENCE';
export const FETCH_INVOICE_NUMBER_SEQUENCE_SUCCESS = 'FETCH_INVOICE_NUMBER_SEQUENCE_SUCCESS';
export const FETCH_INVOICE_NUMBER_SEQUENCE_FAILED = 'FETCH_INVOICE_NUMBER_SEQUENCE_FAILED';
export const FETCH_ALL_INVOICE_NUMBER_SEQUENCE = 'FETCH_ALL_INVOICE_NUMBER_SEQUENCE';
export const FETCH_ALL_INVOICE_NUMBER_SEQUENCE_SUCCESS = 'FETCH_ALL_INVOICE_NUMBER_SEQUENCE_SUCCESS';
export const FETCH_ALL_INVOICE_NUMBER_SEQUENCE_FAILED = 'FETCH_ALL_INVOICE_NUMBER_SEQUENCE_FAILED';
const DELETE_INVOICE_NUMBER_SEQUENCE = 'DELETE_INVOICE_NUMBER_SEQUENCE';
export const DELETE_INVOICE_NUMBER_SEQUENCE_SUCCESS = 'DELETE_INVOICE_NUMBER_SEQUENCE_SUCCESS';
const DELETE_INVOICE_NUMBER_SEQUENCE_FAILED = 'DELETE_INVOICE_NUMBER_SEQUENCE_FAILED';
export const UPDATE_INVOICE_NUMBER_SEQUENCE = 'UPDATE_INVOICE_NUMBER_SEQUENCE';
export const UPDATE_INVOICE_NUMBER_SEQUENCE_SUCCESS = 'UPDATE_INVOICE_NUMBER_SEQUENCE_SUCCESS';
const UPDATE_INVOICE_NUMBER_SEQUENCE_FAILED = 'UPDATE_INVOICE_NUMBER_SEQUENCE_FAILED';
export const CREATE_INVOICE_NUMBER_SEQUENCE = 'CREATE_INVOICE_NUMBER_SEQUENCE';
export const CREATE_INVOICE_NUMBER_SEQUENCE_SUCCESS = 'CREATE_INVOICE_NUMBER_SEQUENCE_SUCCESS';
const CREATE_INVOICE_NUMBER_SEQUENCE_FAILED = 'CREATE_INVOICE_NUMBER_SEQUENCE_FAILED';
const CREATE_INVOICE_NUMBER_SEQUENCE_FAILED_NON_UNIQUE_PROPERTIES =
    'CREATE_INVOICE_NUMBER_SEQUENCE_FAILED_NON_UNIQUE_PROPERTIES';
const UPDATE_INVOICE_NUMBER_SEQUENCE_FAILED_NON_UNIQUE_PROPERTIES =
    'UPDATE_INVOICE_NUMBER_SEQUENCE_FAILED_NON_UNIQUE_PROPERTIES';
const FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS = 'FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS';
export const FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_SUCCESS =
    'FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_SUCCESS';
const FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_FAILED =
    'FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_FAILED';
const FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY = 'FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY';
export const FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_SUCCESS = 'FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_SUCCESS';
const FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_FAILED = 'FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_FAILED';
export const INVOICE_NUMBER_SEQUENCE_ERROR = 'INVOICE_NUMBER_SEQUENCE_ERROR';
export const FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY = 'FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY';
export const FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_SUCCESS =
    'FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_SUCCESS';
export const FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_ERROR =
    'FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_ERROR';

export const fetchInvoiceNumberSequences = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE });

        const response = await api.invoiceNumberSequences.cget(searchParams);

        if (response.success) {
            dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_SUCCESS, invoiceNumberSequences: response.result });
        } else {
            dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchAllInvoiceNumberSequences = (searchParams?: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: FETCH_ALL_INVOICE_NUMBER_SEQUENCE });

        const response = await api.invoiceNumberSequences.cgetAll(searchParams);

        if (response.success) {
            dispatch({ type: FETCH_ALL_INVOICE_NUMBER_SEQUENCE_SUCCESS, invoiceNumberSequencesAll: response.result });
        } else {
            dispatch({ type: FETCH_ALL_INVOICE_NUMBER_SEQUENCE_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchAvailableSuppliers = (searchParams?: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS });

        const response = await api.invoiceNumberSequences.getAvailableSuppliers(searchParams);

        if (response.success) {
            dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_SUCCESS, suppliers: response.result });
        } else {
            dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteInvoiceNumberSequence = (invoiceNumberSequenceId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: DELETE_INVOICE_NUMBER_SEQUENCE });

        const response = await api.invoiceNumberSequences.deleteInvoiceNumberSequence(invoiceNumberSequenceId);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.invoiceNumberSequenceDeleted')));
            dispatch({ type: DELETE_INVOICE_NUMBER_SEQUENCE_SUCCESS, invoiceNumberSequenceId });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            dispatch({ type: DELETE_INVOICE_NUMBER_SEQUENCE_FAILED });
        }
    };
};

export const updateInvoiceNumberSequence = (
    id: number,
    invoiceNumberSequence: InvoiceNumberSequenceRequest,
    isDefault: boolean
) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: UPDATE_INVOICE_NUMBER_SEQUENCE });

        const response = await api.invoiceNumberSequences.updateInvoiceNumberSequence(
            id,
            invoiceNumberSequence,
            isDefault
        );

        if (response.success) {
            dispatch({
                type: UPDATE_INVOICE_NUMBER_SEQUENCE_SUCCESS,
                invoiceNumberSequence: response.result,
            });
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.invoiceNumberSequenceUpdated')));
        } else if (response.error?.title === ErrorMessage.NonUniqueProperties) {
            dispatch({ type: UPDATE_INVOICE_NUMBER_SEQUENCE_FAILED_NON_UNIQUE_PROPERTIES });
            dispatch({ type: INVOICE_NUMBER_SEQUENCE_ERROR, errorMessage: 'app.error.alreadyTaken' });
        } else {
            dispatch({ type: UPDATE_INVOICE_NUMBER_SEQUENCE_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response;
    };
};

export const createInvoiceNumberSequence = (invoiceNumberSequence: InvoiceNumberSequenceRequest) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CREATE_INVOICE_NUMBER_SEQUENCE });

        const response = await api.invoiceNumberSequences.createInvoiceNumberSequence(invoiceNumberSequence);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.invoiceNumberSequenceCreated')));
            dispatch({ type: CREATE_INVOICE_NUMBER_SEQUENCE_SUCCESS, invoiceNumberSequence: response.result });
        } else if (response.error?.title === ErrorMessage.NonUniqueProperties) {
            dispatch({ type: CREATE_INVOICE_NUMBER_SEQUENCE_FAILED_NON_UNIQUE_PROPERTIES });
            dispatch({ type: INVOICE_NUMBER_SEQUENCE_ERROR, errorMessage: 'app.error.alreadyTaken' });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            dispatch({ type: CREATE_INVOICE_NUMBER_SEQUENCE_FAILED });
        }

        return response;
    };
};

export const fetchInvoiceNumberSequenceHistory = (search?: string) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY });

        const response = await api.invoiceNumberSequences.getInvoiceNumberSequenceHistory(search);

        if (response.success) {
            dispatch({
                type: FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_SUCCESS,
                invoiceNumberSequenceHistory: response.result,
            });
        } else {
            dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchInvoiceNumberSequenceSupplierHistory = (params: { supplierId: number; search?: string }) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY });

        const response = await api.invoiceNumberSequences.getInvoiceNumberSequenceSupplierHistory(
            params.supplierId,
            params.search
        );

        if (response.success) {
            dispatch({
                type: FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_SUCCESS,
                invoiceNumberSequenceHistory: response.result,
            });
        } else {
            dispatch({ type: FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
